import { render, staticRenderFns } from "./HelperBiometria.vue?vue&type=template&id=c2695f30&scoped=true"
import script from "./HelperBiometria.vue?vue&type=script&lang=js"
export * from "./HelperBiometria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2695f30",
  null
  
)

export default component.exports